 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~06837ae4": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~06837ae4": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~987e6011":"chunk-commons~987e6011","chunk-commons~690b702c":"chunk-commons~690b702c","chunk-commons~e258e298":"chunk-commons~e258e298","chunk-commons~8eeb4602":"chunk-commons~8eeb4602","chunk-commons~15f0789d":"chunk-commons~15f0789d","chunk-commons~cc99a214":"chunk-commons~cc99a214","chunk-commons~f850c546":"chunk-commons~f850c546","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~558ff103":"chunk-commons~558ff103","user~6e76d53f":"user~6e76d53f","sentiment~21833f8f":"sentiment~21833f8f","home~31ecd969":"home~31ecd969"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"88c9abdf","chunk-19b0cf18":"80d10044","chunk-2d0aab45":"964ba9a5","chunk-2d0b6737":"b55dbd71","chunk-2d0cc1d9":"f1b07c2c","chunk-2d0dd612":"6a95ed5f","chunk-2fd16595":"40867432","chunk-3d370fbd":"b9aa4331","chunk-4fc4313d":"4f380986","chunk-5069aa76":"a67a15e3","chunk-617a8429":"3be0ec2e","chunk-commons~31ecd969":"1dacc488","chunk-commons~987e6011":"bab580c4","chunk-commons~690b702c":"d90d3f3e","chunk-commons~e258e298":"22868467","chunk-commons~8eeb4602":"88669289","chunk-commons~15f0789d":"b18b4435","chunk-commons~cc99a214":"41da3647","chunk-commons~f850c546":"158ce4b9","chunk-commons~21833f8f":"0a0a56ea","chunk-commons~558ff103":"c1b41c2e","chunk-2710fcfb":"d76166e4","chunk-ab48b786":"e281058c","chunk-ab9a24e2":"ee901331","chunk-b5b110c4":"5ad93eb2","user~6e76d53f":"b0ad664c","chunk-3aa3110e":"24f4f54a","chunk-0ae04c33":"0c5dd484","chunk-17501b26":"0544b7e2","chunk-1ef999a0":"0a80040d","chunk-278f15c2":"1f9a1b70","chunk-2d0a30ec":"02b05572","chunk-2d0c917a":"cbf5d87b","chunk-2d0da362":"967b8d62","chunk-2d0daf52":"ac498d3a","chunk-2d0e4810":"d268dfc6","chunk-2d0efccf":"52022a9f","chunk-2d207d1a":"825c2bab","chunk-2d2140d8":"40d72476","chunk-2d217776":"2742dfba","chunk-2d226c7a":"76312af4","chunk-35669c0e":"ad953e93","chunk-4962705e":"ec376d5a","chunk-4b940c1f":"9a183a09","chunk-6c227dc0":"5d80bbec","chunk-c2f51d2a":"31cad3c8","chunk-c805ad42":"7bab97a2","chunk-dbc48d1e":"aaf3a309","sentiment~21833f8f":"2a9d19e2","chunk-ef584cd2":"8bc27320","chunk-f8e06ac8":"ccf1f5ec","home~31ecd969":"4d51f886","chunk-69e981a5":"168caac5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05a29214":1,"chunk-19b0cf18":1,"chunk-3d370fbd":1,"chunk-4fc4313d":1,"chunk-617a8429":1,"chunk-commons~31ecd969":1,"chunk-commons~21833f8f":1,"chunk-commons~558ff103":1,"chunk-2710fcfb":1,"chunk-ab48b786":1,"chunk-ab9a24e2":1,"chunk-b5b110c4":1,"user~6e76d53f":1,"chunk-3aa3110e":1,"chunk-0ae04c33":1,"chunk-17501b26":1,"chunk-1ef999a0":1,"chunk-278f15c2":1,"chunk-35669c0e":1,"chunk-4962705e":1,"chunk-4b940c1f":1,"chunk-6c227dc0":1,"chunk-c2f51d2a":1,"chunk-c805ad42":1,"chunk-dbc48d1e":1,"chunk-ef584cd2":1,"chunk-f8e06ac8":1,"home~31ecd969":1,"chunk-69e981a5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~987e6011":"chunk-commons~987e6011","chunk-commons~690b702c":"chunk-commons~690b702c","chunk-commons~e258e298":"chunk-commons~e258e298","chunk-commons~8eeb4602":"chunk-commons~8eeb4602","chunk-commons~15f0789d":"chunk-commons~15f0789d","chunk-commons~cc99a214":"chunk-commons~cc99a214","chunk-commons~f850c546":"chunk-commons~f850c546","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~558ff103":"chunk-commons~558ff103","user~6e76d53f":"user~6e76d53f","sentiment~21833f8f":"sentiment~21833f8f","home~31ecd969":"home~31ecd969"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"20d2b46c","chunk-19b0cf18":"3a86a2cb","chunk-2d0aab45":"31d6cfe0","chunk-2d0b6737":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2d0dd612":"31d6cfe0","chunk-2fd16595":"31d6cfe0","chunk-3d370fbd":"064cab12","chunk-4fc4313d":"80994280","chunk-5069aa76":"31d6cfe0","chunk-617a8429":"7b9d494e","chunk-commons~31ecd969":"6dc57fe0","chunk-commons~987e6011":"31d6cfe0","chunk-commons~690b702c":"31d6cfe0","chunk-commons~e258e298":"31d6cfe0","chunk-commons~8eeb4602":"31d6cfe0","chunk-commons~15f0789d":"31d6cfe0","chunk-commons~cc99a214":"31d6cfe0","chunk-commons~f850c546":"31d6cfe0","chunk-commons~21833f8f":"e948d623","chunk-commons~558ff103":"74247bec","chunk-2710fcfb":"f823ba86","chunk-ab48b786":"1463a986","chunk-ab9a24e2":"b1c92d63","chunk-b5b110c4":"cad0d605","user~6e76d53f":"6fb613ca","chunk-3aa3110e":"f2fb161f","chunk-0ae04c33":"28cf586b","chunk-17501b26":"b5225808","chunk-1ef999a0":"d8857b04","chunk-278f15c2":"5c5c2664","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-35669c0e":"4c4de6e1","chunk-4962705e":"35010b62","chunk-4b940c1f":"9884cc5d","chunk-6c227dc0":"4ed08d7c","chunk-c2f51d2a":"4af368f8","chunk-c805ad42":"3b72b7fe","chunk-dbc48d1e":"47d9aba4","sentiment~21833f8f":"31d6cfe0","chunk-ef584cd2":"c7f95f68","chunk-f8e06ac8":"5e49fa7a","home~31ecd969":"6f662d41","chunk-69e981a5":"747d1e9c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-echarts~2aec3c5f","chunk-echarts~ec219104","chunk-echarts~be6a9b4d","chunk-echarts~a3df519a","chunk-echarts~ed9be1e3","chunk-echarts~d71bf088","chunk-echarts~717e1328","chunk-echarts~41ff223c","chunk-echarts~26381bd2","chunk-echarts~a31b3962","chunk-echarts~88ded296","chunk-echarts~f3137b1a","chunk-echarts~64e68313","chunk-echarts~dc26c9a5","chunk-echarts~588225d9","chunk-echarts~4813aef3","chunk-echarts~bdcda83c","chunk-echarts~16d3814e","chunk-echarts~ef4b7b69","chunk-echarts~5f2a7c9c","chunk-echarts~3fc0db22","chunk-echarts~faa5bc4a","chunk-bootstrap~e56a07c4","chunk-bootstrap~6f27f355","chunk-bootstrap~5ce4fade","chunk-bootstrap~eb7344d5","chunk-bootstrap~ab9cc731","chunk-bootstrap~f414210c","chunk-bootstrap~6bcf42e1","chunk-bootstrap~1187b811","chunk-bootstrap~7a8621bb","chunk-bootstrap~3567b4a7","chunk-bootstrap~7e2e2373","chunk-bootstrap~f8ef863f","chunk-bootstrap~52f44a73","chunk-bootstrap~36c5d7d2","chunk-bootstrap~05504061","app~d0ae3f07","app~d939e436","app~d2305125","app~2900d54e","app~308aa24e","app~cfcd6536","app~f538a826","app~fd542d86","app~2e545ea6"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
